import styled from 'styled-components';
import { fontSizeXs, spacingLg, gray } from 'utils/variables';

export const Text = styled.p`
  font-size: ${fontSizeXs};
  margin-top: ${spacingLg};
  color: ${gray};
`;
